
"use strict";

class CustomerProfileAccessController {

  constructor($parse, $window, $timeout, SSHttpService, SSUtilService, SSConfigService, SSUserService, SSAppService, SSAwsService, SSAlertService) {
    const self = this;

    self.$parse = $parse;
    self.$window = $window;
    self.$timeout = $timeout;

    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSConfigService = SSConfigService;
    self.SSUserService = SSUserService;
    self.SSAppService = SSAppService;
    self.SSAwsService = SSAwsService;
    self.SSAlertService = SSAlertService;

    self.VALIDATION_TOKEN_TYPE_ACCOUNT_ACTIVATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_ACCOUNT_ACTIVATION;
    self.VALIDATION_TOKEN_TYPE_FORGOT_PASSWORD = SHOWSUITE.VALIDATION_TOKEN_TYPE_FORGOT_PASSWORD;
    self.VALIDATION_TOKEN_TYPE_ENQUIRY_VERIFICATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_ENQUIRY_VERIFICATION;
    self.VALIDATION_TOKEN_TYPE_ACCOUNT_INVITATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_ACCOUNT_INVITATION;

    self.VALIDATION_TOKEN_TYPE_BROKER_BUYER_AUTHORISATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_BROKER_BUYER_AUTHORISATION;
    self.VALIDATION_TOKEN_TYPE_USER_BUYER_AUTHORISATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_USER_BUYER_AUTHORISATION;

    self.VALIDATION_TOKEN_TYPE_BUYER_CONTACT_VERIFICATION = SHOWSUITE.VALIDATION_TOKEN_TYPE_BUYER_CONTACT_VERIFICATION;

    self.buyer_id = SHOWSUITE.data.buyer_id;
    
    self.init();
  }

  init() {
    const self = this;

    // Get current user
    self.user = self.SSUserService.getUser();
    if (!self.user) {
      self.SSUserService.showLoginModal();
    }

    console.log('self.user');
    console.log(self.user);

    self.access_requests = null;
    self.getAccessRequest();

    self.access_list = [];
    self.getAccessList();

  }

  getAccessRequest(){
    const self = this;

    let url = 'sec/buyers/access-requests';

    loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }
      console.log('response.data');
      console.log(response.data);

      self.access_requests = response.data.validation_tokens;
      let users = response.data.users;

      $.each(self.access_requests, function(index, request){
        let data = JSON.parse(request.data);
        request["requested_by"] = users.find(x => x.id == data.user_id);

        if(request.requested_by.display_name){
          request["requested_by"]["name"] = request.requested_by.display_name;
        }
        else{
          request["requested_by"]["name"] = request.requested_by.first_name + ' ' + request.requested_by.last_name;
        }

        if(request.type == self.VALIDATION_TOKEN_TYPE_BROKER_BUYER_AUTHORISATION){
          request["request_type"] = "Broker";
        }
        else if(request.type == self.VALIDATION_TOKEN_TYPE_USER_BUYER_AUTHORISATION){
          request["request_type"] = "Buyer";
        }
        else{
          request["request_type"] = "--";
        }
      });

      console.log('self.access_requests');
      console.log(self.access_requests);

    });
  }

  approveRequest(token){
    const self = this;

    let url = 'verify/' + token;

    loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }
      self.SSAlertService.success('Success!', 'Request approved successfully');
      // Refresh page
      self.$window.location.reload();

    });

  }

  getAccessList(){
    const self = this;

    let url = 'sec/buyers/'+ self.buyer_id +'/access-list';

    loading(true);
    self.SSHttpService.getAPIRequest(url).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
      }
      console.log('response.data');
      console.log(response.data);

      $.each(response.data.brokers_user_data, function(index, obj){
        obj["type"] = self.VALIDATION_TOKEN_TYPE_BROKER_BUYER_AUTHORISATION;
        self.access_list.push(obj);
      });

      $.each(response.data.users, function(index, obj){
        obj["type"] = self.VALIDATION_TOKEN_TYPE_USER_BUYER_AUTHORISATION;
        if(self.user.id != obj.id){
          self.access_list.push(obj);
        }
      });

      console.log('self.access_list');
      console.log(self.access_list);
    });
  }

  revokeAccess(user){
    const self = this;

    let url = 'sec/buyers/' + self.buyer_id;
    let params = {};

    if(user.type == self.VALIDATION_TOKEN_TYPE_BROKER_BUYER_AUTHORISATION){
      params = {
        'broker_user_id': user.id
      }
    }
    else if(user.type == self.VALIDATION_TOKEN_TYPE_USER_BUYER_AUTHORISATION){
      let params = {
        'user_id': user.id
      }
    }
    
    loading(true);
    self.SSHttpService.deleteAPIRequest(url, params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
          self.SSAlertService.danger('Error!', response.message);
          return;
      }
      self.SSAlertService.success('Success!', 'Access revoked successfully');
      // Refresh page
      self.$window.location.reload();

    });

  }

}

CustomerProfileAccessController.$inject = ['$parse', '$window', '$timeout', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSUserService', 'SSAppService', 'SSAwsService', 'SSAlertService'];
app.controller('CustomerProfileAccessController', CustomerProfileAccessController);
